import { call, fork, put, takeEvery } from 'redux-saga/effects';
import {
  fetchWhiteListFail,
  fetchWhiteListSuccess,
  FETCH_WHITELIST
} from '../../redux/actions/cm/whiteList';
import {
  APPROVE_CUSTOMERS,
  DELETE_CUSTOMERS,
  FETCH_WHITELIST_DETAILS,
  UPDATE_WHITELIST_NAME,
  approveCustomersFail,
  approveCustomersSuccess,
  deleteCustomersFail,
  deleteCustomersSuccess,
  fetchWhiteListDetailsFail,
  fetchWhiteListDetailsSuccess,
  updateWhitelistNameFail,
  updateWhitelistNameSuccess
} from '../../redux/actions/cm/whitelistDetails';
import {
  approveCustomers,
  deleteCustomers,
  fetchWhiteList,
  fetchWhiteListDetails,
  updateWhitelistName
} from '../../services/cm/whitelist';

function* fetchWhiteListWorker({ searchText, currentPage, pageSize }) {
  try {
    const { whitelistData, total } = yield call(fetchWhiteList, {
      searchText,
      currentPage,
      pageSize
    });

    yield put(fetchWhiteListSuccess({ whitelistData, total }));
  } catch (error) {
    yield put(fetchWhiteListFail());
  }
}

export function* watchFetchWhiteList() {
  yield takeEvery(
    FETCH_WHITELIST,
    function* ({ payload: { searchText, currentPage, pageSize } }) {
      yield fork(fetchWhiteListWorker, {
        searchText,
        currentPage,
        pageSize
      });
    }
  );
}

function* fetchWhiteListDetailsWorker({ id, currentPage, pageSize, filters }) {
  try {
    const whitelistDetails = yield call(fetchWhiteListDetails, {
      id,
      currentPage,
      pageSize,
      filters
    });

    yield put(fetchWhiteListDetailsSuccess({ whitelistDetails }));
  } catch (error) {
    yield put(fetchWhiteListDetailsFail(error.message));
  }
}

export function* watchFetchWhiteListDetails() {
  yield takeEvery(
    FETCH_WHITELIST_DETAILS,
    function* ({ payload: { id, currentPage, pageSize, filters } }) {
      yield fork(fetchWhiteListDetailsWorker, {
        id,
        currentPage,
        pageSize,
        filters
      });
    }
  );
}

function* updateWhitelistNameWorker({ id, name }) {
  try {
    yield call(updateWhitelistName, { id, name });
    yield put(updateWhitelistNameSuccess());
  } catch (error) {
    yield put(updateWhitelistNameFail(error.message));
  }
}

export function* watchUpdateWhitelistName() {
  yield takeEvery(UPDATE_WHITELIST_NAME, function* ({ payload: { id, name } }) {
    yield fork(updateWhitelistNameWorker, {
      id,
      name
    });
  });
}

function* approveCustomersWorker({ customerIds, whitelistId }) {
  try {
    yield call(approveCustomers, { customerIds, whitelistId });
    yield put(approveCustomersSuccess());
  } catch (error) {
    yield put(approveCustomersFail(error.message));
  }
}

export function* watchApproveCustomers() {
  yield takeEvery(
    APPROVE_CUSTOMERS,
    function* ({ payload: { customerIds, whitelistId } }) {
      yield fork(approveCustomersWorker, { customerIds, whitelistId });
    }
  );
}

function* deleteCustomersWorker({ customerIds, whitelistId }) {
  try {
    yield call(deleteCustomers, { customerIds, whitelistId });
    yield put(deleteCustomersSuccess());
  } catch (error) {
    yield put(deleteCustomersFail(error.message));
  }
}

export function* watchDeleteCustomers() {
  yield takeEvery(
    DELETE_CUSTOMERS,
    function* ({ payload: { customerIds, whitelistId } }) {
      yield fork(deleteCustomersWorker, { customerIds, whitelistId });
    }
  );
}
